import _styled6 from "styled-components";
import _styled5 from "styled-components";
import _styled4 from "styled-components";
import _styled3 from "styled-components";
import _styled2 from "styled-components";
import _styled from "styled-components";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import * as styles from './Input.style';
import { ICON_ALERT_CIRCLE } from '../../icons';
import Symbol from '../symbol/Symbol';
import Spinner, { SpinnerSize } from '../spinner/Spinner';
export const Input = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    dataRef = 'input',
    prefixElement,
    error = false,
    value,
    loading = false,
    disabled = false,
    id,
    type = 'text',
    name,
    required = false,
    icon,
    valid,
    onBlur,
    onFocus,
    onClickIcon,
    ...rest
  } = _ref;
  const [isFocused, setIsFocused] = React.useState(false);
  const inputRef = React.useRef(null);
  React.useImperativeHandle(ref, () => inputRef.current);
  const onInputFocus = React.useCallback(event => {
    setIsFocused(false);
    onFocus?.(event);
  }, [onFocus]);
  const onInputBlur = React.useCallback(event => {
    setIsFocused(false);
    onBlur?.(event);
  }, [onBlur]);
  const focusInput = React.useCallback(() => {
    inputRef.current?.focus();
  }, []);
  const onIconClick = React.useCallback(event => {
    onClickIcon?.(event);
    focusInput();
  }, [focusInput, onClickIcon]);
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    "data-ref": dataRef,
    $hidden: type === 'hidden',
    $_css: styles.base
  }, prefixElement && /*#__PURE__*/React.createElement(_StyledDiv2, {
    $error: error,
    $value: value,
    $disabled: disabled,
    $_css2: styles.prefix
  }, prefixElement), /*#__PURE__*/React.createElement(_StyledInput, _extends({
    id: id,
    $hasIcon: error && !isFocused || loading || icon && !loading,
    type: type,
    name: name,
    required: required,
    "aria-required": required,
    $valid: valid,
    $error: error,
    "data-ref": `${dataRef}-input`,
    disabled: disabled,
    $prefix: prefixElement,
    value: value
  }, rest, {
    ref: inputRef,
    onFocus: onInputFocus,
    onBlur: onInputBlur,
    $_css3: styles.input
  })), error && !isFocused && /*#__PURE__*/React.createElement(_StyledButton, {
    $error: error,
    $valid: valid,
    $isVisible: true,
    $isValidationIcon: true,
    onClick: focusInput,
    type: "button",
    "data-testid": "validation-error-icon",
    $_css4: styles.icon
  }, /*#__PURE__*/React.createElement(Symbol, {
    path: ICON_ALERT_CIRCLE,
    size: styles.SYMBOL_SIZE
  })), loading && /*#__PURE__*/React.createElement(_StyledDiv3, {
    $_css5: styles.overlay
  }, /*#__PURE__*/React.createElement(Spinner, {
    size: SpinnerSize.SMALLER,
    color: "neutrals.medium"
  })), !loading && icon && /*#__PURE__*/React.createElement(_StyledButton2, {
    $isVisible: !error && !valid || isFocused,
    disabled: disabled,
    $filled: value,
    onClick: onIconClick,
    onMouseDown: e => e.preventDefault(),
    type: "button",
    $_css6: styles.icon
  }, /*#__PURE__*/React.createElement(Symbol, {
    path: icon,
    size: styles.SYMBOL_SIZE
  })));
});
export default Input;
var _StyledDiv = _styled("div").withConfig({
  displayName: "Input___StyledDiv",
  componentId: "sc-iq8vgy-0"
})(["", ""], p => p.$_css);
var _StyledDiv2 = _styled("div").withConfig({
  displayName: "Input___StyledDiv2",
  componentId: "sc-iq8vgy-1"
})(["", ""], p => p.$_css2);
var _StyledInput = _styled("input").withConfig({
  displayName: "Input___StyledInput",
  componentId: "sc-iq8vgy-2"
})(["", ""], p => p.$_css3);
var _StyledButton = _styled("button").withConfig({
  displayName: "Input___StyledButton",
  componentId: "sc-iq8vgy-3"
})(["", ""], p => p.$_css4);
var _StyledDiv3 = _styled("div").withConfig({
  displayName: "Input___StyledDiv3",
  componentId: "sc-iq8vgy-4"
})(["", ""], p => p.$_css5);
var _StyledButton2 = _styled("button").withConfig({
  displayName: "Input___StyledButton2",
  componentId: "sc-iq8vgy-5"
})(["", ""], p => p.$_css6);
//# sourceMappingURL=Input.js.map